import { render, staticRenderFns } from "./Waiters.vue?vue&type=template&id=281a10e6&"
import script from "./Waiters.vue?vue&type=script&lang=js&"
export * from "./Waiters.vue?vue&type=script&lang=js&"
import style0 from "./Waiters.vue?vue&type=style&index=0&id=281a10e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports